<!--<div class="order-contractor-preview">-->
<!--	<div class="order-contractor-preview__top">-->
<!--		<div class="order-contractor-preview__head">-->
<!--			<div class="order-contractor-preview__title">-->
<!--				<div class="order-contractor-preview__logo">-->
<!--					<epic-icon name="order-customers" />-->
<!--				</div>-->
<!--				<div-->
<!--					class="font__heading-3 font-weight__semibold"-->
<!--					i18n="description: Contractor title @@orderContractorPreviewTitle">-->
<!--					Contractor-->
<!--				</div>-->
<!--			</div>-->
<div class="order-contractor-preview__btn row gap--small">
	<epic-button
		(click)="openCustomerCorrespondenceModal()"
		size="medium"
		classes="epic-button--custom_submit"
		[epic-tooltip]="textCustomerCorrespondence">
		<epic-icon [name]="'chat-square-dots'" />
	</epic-button>
	<epic-icon-button
		(click)="contractorDetailsClick()"
		[text]="textShowContractor"
		[iconHoverQuerySelector]="'path'"
		[background]="'var(--color__white)'"
		[hoverColor]="'var(--color__dark)'"
		[iconHoverColor]="'var(--color__white)'"
		[tooltipTextColor]="'var(--color__white)'"
		[iconName]="'user-eye'" />
</div>
<!--		</div>-->
<!--		<div class="order-contractor-preview__body">-->
<!--			<div class="order-contractor-preview__item form__element-12 form">-->
<!--				<div-->
<!--					class="order-contractor-preview__name form__element-4 font__small"-->
<!--					i18n="description: Contact Person in contractor preview @@orderContractorPreviewContactPerson">-->
<!--					Contact Person:-->
<!--				</div>-->
<!--				<div class="order-contractor-preview__value form__element-8 font__medium font-weight__medium">-->
<!--					{{ model.entity?.contractor?.contact_detail?.first_name }}-->
<!--					{{ model.entity?.contractor?.contact_detail?.last_name }}-->
<!--				</div>-->
<!--			</div>-->
<!--			<div class="order-contractor-preview__item form__element-12 form">-->
<!--				<div-->
<!--					class="order-contractor-preview__name form__element-4 font__small"-->
<!--					i18n="description: Email in contractor preview @@orderContractorPreviewEmail">-->
<!--					Email:-->
<!--				</div>-->
<!--				<div class="order-contractor-preview__value form__element-8 font__medium">-->
<!--					@if (model.entity?.contractor?.contact_detail?.emails) {-->
<!--						@for (email of model.entity?.contractor?.contact_detail?.emails; let last = $last; track $index) {-->
<!--							<div>-->
<!--								<a [href]="'mailto:' + email.value">{{ email.value }}</a>-->
<!--								@if (!last) {-->
<!--									<span>, </span>-->
<!--								}-->
<!--							</div>-->
<!--						}-->
<!--					} @else {-->
<!--						- -->
<!--					}-->
<!--				</div>-->
<!--			</div>-->
<!--			<div class="order-contractor-preview__item form__element-12 form">-->
<!--				<div-->
<!--					class="order-contractor-preview__name form__element-4 font__small"-->
<!--					i18n="description: Phone in contractor preview @@orderContractorPreviewPhone">-->
<!--					Phone:-->
<!--				</div>-->
<!--				<div class="order-contractor-preview__value form__element-8 font__medium font-weight__medium">-->
<!--					@if (model.entity?.contractor?.contact_detail?.phones) {-->
<!--						@for (phone of model.entity?.contractor?.contact_detail?.phones; let last = $last; track $index) {-->
<!--							<div>-->
<!--								<a [href]="'tel:' + phone.value">{{ phone.value }}</a>-->
<!--								@if (!last) {-->
<!--									<span>, </span>-->
<!--								}-->
<!--							</div>-->
<!--						}-->
<!--					} @else {-->
<!--						- -->
<!--					}-->
<!--				</div>-->
<!--			</div>-->
<!--			<div class="order-contractor-preview__item form__element-12 form">-->
<!--				<div-->
<!--					class="order-contractor-preview__name form__element-4 font__small"-->
<!--					i18n="description: Company Name in contractor preview @@orderContractorPreviewCompanyName">-->
<!--					Company Name:-->
<!--				</div>-->
<!--				<div class="order-contractor-preview__value form__element-8 font__medium">-->
<!--					{{ model.entity?.name }}-->
<!--				</div>-->
<!--			</div>-->
<!--			@if (model.entity?.short_name) {-->
<!--				<div class="order-contractor-preview__item form__element-12 form">-->
<!--					<div-->
<!--						class="order-contractor-preview__name form__element-4 font__small"-->
<!--						i18n="description: Company Name in contractor preview">-->
<!--						Abbreviated company name:-->
<!--					</div>-->
<!--					<div class="order-contractor-preview__value form__element-8 font__medium">-->
<!--						{{ model.entity?.short_name }}-->
<!--					</div>-->
<!--				</div>-->
<!--			}-->
<!--		</div>-->
<!--	</div>-->
<!--</div>-->
